/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  Series,
  Range,
  AggregateValuesType,
} from '..';
import {
  serializeRange,
} from '..';
import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface GetAggregateInput {
  serial: string;
  series: Series;
  range?: Range;
  type: string;
}
const build = (_query: DocumentNode, input: GetAggregateInput, name = 'QueryResult') => {
  const bQuery = `
  query ${ name }(`+
    ( input.serial !== undefined ? `$serial: String = ${JSON.stringify(input.serial).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.series !== undefined ? `$series: Series = ${input.series}, ` : '' ) + ``+
    ( input.range !== undefined ? `$range: Range = ${serializeRange(input.range)}, ` : '' ) + ``+
    ( input.type !== undefined ? `$type: String = ${JSON.stringify(input.type).replace(/"(\w+)":/g, '$1:')}` : '' ) + `){
    getAggregate(
      ${ input.serial !== undefined ? 'serial: $serial,' : '' } 
      ${ input.series !== undefined ? 'series: $series,' : '' } 
      ${ input.range !== undefined ? 'range: $range,' : '' } 
      ${ input.type !== undefined ? 'type: $type,' : '' }
    ){
      ...aggregatevaluestype
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class GetAggregateQuery {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment aggregatevaluestype on AggregateValuesType { ... }
   */
  async execute(_query: DocumentNode, input: GetAggregateInput, refresh = false) {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    const fetchPolicy = refresh ? 'network-only' : 'cache-first';
   return await client?.query<{ getAggregate: Partial<AggregateValuesType>[] }>({ query: build(_query, input), fetchPolicy });
  }
}
